<template>
  <vs-popup id="PopupPrivacyPolicy" title="동국제강 안전환경 통합전산시스템 개인정보 처리방침" :active.sync="showPopup">
    <div class="px-3">
      <section>
        <h4 class="mb-2 py-3 text-center">동국제강 안전환경 통합전산시스템 개인정보 처리방침</h4>
        <p>
          동국제강은 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에 따라 정보주체에게 개인정보 처리에 관한
          절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
        </p>
      </section>

      <section>
        <h4>■ 목차</h4>
        <div class="overflow-x-auto">
          <table class="w-full" style="min-width: 640px">
            <colgroup>
              <col style="width: 50%" />
              <col style="width: 50%" />
            </colgroup>
            <tr>
              <td class="p-4">
                <ul style="list-style: ' • ' inside">
                  <li>개인정보의 처리 목적</li>
                  <li>개인정보의 처리 및 보유기간</li>
                  <li>개인정보 처리의 위탁</li>
                  <li>개인정보의 제3자 제공</li>
                  <li>개인정보의 파기 절차 및 방법</li>
                  <li>정보주체와 법정대리인의권리·의무 및 행사방법</li>
                </ul>
              </td>
              <td class="p-4">
                <ul style="list-style: '• ' inside">
                  <li>개인정보의 안전성 확보조치</li>
                  <li>개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</li>
                  <li>개인정보 보호책임자</li>
                  <li>개인정보 열람청구</li>
                  <li>권익침해 구제방법</li>
                  <li>개인정보 처리방침의 변경</li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
      </section>

      <section>
        <h4>■ 개인정보의 처리 목적</h4>
        <ul>
          <li class="content" data-content="①">
            <p>
              동국제강은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며 이용 목적이 변경되는 경우에는 「개인정보보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를
              이행할 예정입니다.
            </p>
            <ul>
              <li class="content" data-content="1.">
                <p>서비스 제공</p>
                <p>: 안전환경통합전산시스템 서비스 제공(디지털 안전 보건관리)을 위한 본인 식별·인증, 서비스 부정이용 방지, 각종 고지·통지, 고충처리 목적으로 개인정보를 처리합니다.</p>
              </li>
            </ul>
          </li>
        </ul>
      </section>

      <section>
        <h4>■ 개인정보의 처리 및 보유기간</h4>
        <ul>
          <li class="content" data-content="①">동국제강은 법령에 따른 개인정보 보유이〮용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유이〮용기간 내에서 개인정보를 처리보〮유합니다.</li>
          <li class="content" data-content="②">동국제강의 개인정보 처리 및 보유 기간은 다음과 같습니다.</li>
          <li>
            <div class="overflow-x-auto">
              <table class="bg-table" style="min-width: 640px">
                <colgroup>
                  <col style="width: 94px" />
                  <col style="width: 103px" />
                  <col style="width: 180px" />
                  <col style="width: 100px" />
                  <col style="width: 103px" />
                </colgroup>
                <tr>
                  <th rowspan="2">구분</th>
                  <th rowspan="2">업무 분류</th>
                  <th colspan="2">처리 항목</th>
                  <th rowspan="2">보유기간</th>
                </tr>
                <tr>
                  <th>필수항목</th>
                  <th>선택항목</th>
                </tr>
                <tr>
                  <td class="bg-td text-center">안전환경<br />통합시스템</td>
                  <td class="text-center">서비스 제공</td>
                  <td>성명, 생년월일, 사업장 이름, 사업장 관리번호, 전화번호 및 안전·보건 관련 일반 정보</td>
                  <td class="text-center">-</td>
                  <td class="text-center">수집일로부터 3년</td>
                </tr>
              </table>
            </div>
          </li>
          <li class="content" data-content="③">재화 또는 서비스가 제공되는 경우 재화/서비스 공급완료 및 요금결제 정산 완료 시까지 개인정보를 보유하며, 다음 사유에 해당하는 경우 해당 기간 종료 시까지 보유합니다.</li>
          <li>
            <div class="overflow-x-auto">
              <table class="bg-table" style="min-width: 640px">
                <colgroup>
                  <col style="width: 193px" />
                  <col style="width: 193px" />
                  <col style="width: 193px" />
                </colgroup>
                <tr>
                  <th>구분</th>
                  <th>보관정보</th>
                  <th>보유기간</th>
                </tr>
                <tr>
                  <td class="bg-td">「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시광〮고, 계약내용 및 이행 등 거래에 관한 기록</td>
                  <td>소비자 불만 또는 분쟁처리에 관한 기록</td>
                  <td class="text-center">3년</td>
                </tr>
                <tr>
                  <td class="bg-td">「통신비밀보호법」에 따른 통신사실 확인자료 보관</td>
                  <td>컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료</td>
                  <td class="text-center">3개월</td>
                </tr>
              </table>
            </div>
          </li>
        </ul>
      </section>

      <section>
        <h4>■ 개인정보 처리의 위탁</h4>
        <ul>
          <li class="content" data-content="①">동국제강은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</li>
          <li>
            <div class="overflow-x-auto">
              <table class="bg-table" style="min-width: 640px">
                <colgroup>
                  <col style="width: 90px" />
                  <col style="width: 245px" />
                  <col style="width: 245px" />
                </colgroup>
                <tr>
                  <th>구분</th>
                  <th>수탁자</th>
                  <th>위탁업무</th>
                </tr>
                <tr>
                  <td rowspan="3" class="bg-td text-center">안전환경<br />통합시스템</td>
                  <td class="text-center">마엇</td>
                  <td>시스템개발 및 운영</td>
                </tr>
                <tr>
                  <td class="text-center">동국시스템즈</td>
                  <td>클라우드 인프라 관리</td>
                </tr>
                <tr>
                  <td class="text-center">네이버 클라우드</td>
                  <td>클라우드 인프라 운영</td>
                </tr>
              </table>
            </div>
          </li>
          <li class="content" data-content="②">
            동국제강은 위탁계약 체결 시 「개인정보 보호법」제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적관〮리적 보호조치, 재위탁 제한, 수탁자에 대한 관리감〮독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고,
            수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
          </li>
          <li class="content" data-content="③">위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</li>
        </ul>
      </section>

      <section>
        <h4>■ 개인정보의 제3자 제공</h4>
        <p>
          동국제강은 원칙적으로 정보주체의 개인정보를 수집이〮용 목적으로 명시한 범위 내에서 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는
          정보주체의 개인정보를 제3자에게 제공하지 않습니다.
        </p>
      </section>

      <section>
        <h4>■ 개인정보의 파기 절차 및 방법</h4>
        <ul>
          <li class="content" data-content="①">동국제강은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다</li>
          <li class="content" data-content="②">
            정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우 또는 3년 동안 이용하지 않는 경우, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나
            보관장소를 달리하여 보존합니다.
          </li>
          <li class="content" data-content="③">
            <p>개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
            <ul>
              <li class="content" data-content="1.">
                <p>파기절차</p>
                <p>동국제강은 파기 사유가 발생한 개인정보를 선정하고, 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</p>
              </li>
              <li class="content" data-content="2.">
                <p>파기방법</p>
                <p>동국제강은 전자적 파일 형태로 기록‧저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록‧저장된 개인정보는 분쇄기로 분쇄 하거나 소각하여 파기합니다.</p>
              </li>
            </ul>
          </li>
        </ul>
      </section>

      <section>
        <h4>■ 정보주체와 법정대리인의 권리·의무 및 행사방법</h4>
        <ul>
          <li class="content" data-content="①">정보주체와 법정대리인은 동국제강에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.</li>
          <li class="content" data-content="②">권리 행사는 동국제강에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 동국제강은 이에 대해 지체없이 조치하겠습니다.</li>
          <li class="content" data-content="③">개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.</li>
          <li class="content" data-content="④">개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</li>
          <li class="content" data-content="⑤">동국제강은 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리 정지의 요구 시 열람 등 요구를 한 자가 본인인지를 확인합니다.</li>
          <li class="content" data-content="⑥">
            <p>정보주체와 법정대리인은 개인정보의 열람·정정·삭제·처리정지 요구 등 권리행사를 아래의 부서에 할 수 있습니다. 동국제강은 정보주체와 법정대리인의 권리행사가 신속하게 처리되도록 노력하겠습니다.</p>
            <p>부서명 : 안전환경기획팀</p>
            <p>주소 : 서울 중구 을지로5길 19 페럼타워 7층</p>
            <p>전화번호 : 02-317-1187</p>
            <p>이메일 : hyeonsu1.song@dongkuk.com</p>
          </li>
        </ul>
      </section>

      <section>
        <h4>■ 개인정보의 안전성 확보조치</h4>
        <p class="mb-4">동국제강은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
        <ul>
          <li class="content" data-content="1.">
            <p>관리적 조치 : 내부관리계획 수립·시행, 전담조직 운영, 정기적 직원 교육</p>
            <ul>
              <li class="content" data-content="가.">
                <p>회원의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있습니다. 그 최소한의 인원에 해당하는 자는 다음과 같습니다.</p>
                <p>- 회원을 직접 상대로 하여 업무를 수행하는 자</p>
                <p>- 개인정보보호책임자 및 담당자 등 개인정보관리업무를 수행하는 자</p>
                <p>- 기타 업무상 개인정보의 취급이 불가피한 자</p>
              </li>
              <li class="content" data-content="나.">개인정보를 취급하는 직원을 대상으로 새로운 보안 기술 습득 및 개인정보 보호 의무 등에 관해 정기적인 사내교육 및 외부위탁교육을 실시하고 있습니다.</li>
              <li class="content" data-content="다.">
                입사 시 개인정보 관련 취급자의 보안서약서를 통하여 임직원에 의한 정보유출을 사전에 방지하고 개인정보 처리방침에 대한 이행사항 및 직원의 준수여부를 감사하기 위한 내부절차를 마련하고 있습니다.
              </li>
              <li class="content" data-content="라.">개인정보 관련 취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보 사고에 대한 책임을 명확화하고 있습니다.</li>
              <li class="content" data-content="마.">개인정보와 일반 데이터를 혼합하여 보관하지 않고 별도로 분리하여 보관하고 있습니다.</li>
            </ul>
          </li>
          <li class="content" data-content="2.">
            <p>기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치 및 갱신</p>
            <ul>
              <li class="content" data-content="가.">회원의 개인정보 및 비밀번호는 암호화되어 저장 및 관리되며, 중요한 데이터는 파일 및 전송데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.</li>
              <li class="content" data-content="나.">
                백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로 업데이트 되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 회원의 개인정보가
                침해되는 것을 방지하고 있습니다.
              </li>
              <li class="content" data-content="다.">해킹 등 외부침입에 대비하여 침입차단시스템 및 취약점 분석시스템 등을 이용하여 보안에 만전을 기하고 있습니다.</li>
            </ul>
          </li>
          <li class="content" data-content="3.">
            <p>물리적 조치 : 전산실, 자료보관실 등의 접근통제</p>
          </li>
        </ul>
      </section>

      <section>
        <h4>■ 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h4>
        <ul>
          <li class="content" data-content="①">동국제강은 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.</li>
          <li class="content" data-content="②">
            <p>쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도 합니다.</p>
            <ul>
              <li class="content" data-content="가.">쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다</li>
              <li class="content" data-content="나.">쿠키의 설치·운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.</li>
              <li class="content" data-content="다.">쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</li>
            </ul>
          </li>
          <li class="content" data-content="③">쿠키의 거부 : 웹브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.</li>
        </ul>
      </section>

      <section>
        <h4>■ 개인정보 보호책임자</h4>
        <ul>
          <li class="content" data-content="①">
            <p>동국제강은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
          </li>
          <li>
            <div class="overflow-x-auto">
              <table class="bg-table" style="min-width: 640px">
                <colgroup>
                  <col style="width: 132px" />
                  <col style="width: 53px" />
                  <col style="width: 59px" />
                  <col style="width: 42px" />
                  <col style="width: 84px" />
                  <col style="width: 210px" />
                </colgroup>
                <tr>
                  <th>구분</th>
                  <th>성명</th>
                  <th>소속</th>
                  <th>직책</th>
                  <th>연락처</th>
                  <th>E-Mail</th>
                </tr>
                <tr>
                  <td class="bg-td text-center">개인정보보호책임자</td>
                  <td class="text-center">이현희</td>
                  <td class="text-center">지원실</td>
                  <td class="text-center">실장</td>
                  <td class="text-center">02-317-1184</td>
                  <td class="text-center">hyunhee.lee@dongkuk.com</td>
                </tr>
                <tr>
                  <td class="bg-td text-center">개인정보보호담당자</td>
                  <td class="text-center">진상훈</td>
                  <td class="text-center">정보<br />기획팀</td>
                  <td class="text-center">차장</td>
                  <td class="text-center">02-317-1408</td>
                  <td class="text-center">sanghoon.jin@dongkuk.com</td>
                </tr>
                <tr>
                  <td class="bg-td text-center">개인정보처리 담당부서</td>
                  <td class="text-center">송현수</td>
                  <td class="text-center">안전환경<br />기획팀</td>
                  <td class="text-center">대리</td>
                  <td class="text-center">02-317-1187</td>
                  <td class="text-center">hyeonsu1.song@dongkuk.com</td>
                </tr>
              </table>
            </div>
          </li>
          <li class="content" data-content="②">
            정보주체는 동국제강의 서비스를 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 동국제강은 정보주체의 문의에 대해 지체없이 답변 및
            처리해드릴 것입니다.
          </li>
        </ul>
      </section>

      <section>
        <h4>■ 개인정보 열람청구</h4>
        <ul>
          <li>정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 동국제강은 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력 하겠습니다.</li>
          <li>‣ 개인정보 열람청구 접수ㆍ처리 담당부서</li>
          <li>
            <div class="overflow-x-auto">
              <table class="bg-table" style="min-width: 640px">
                <colgroup>
                  <col style="width: 132px" />
                  <col style="width: 119px" />
                  <col style="width: 119px" />
                  <col style="width: 210px" />
                </colgroup>
                <tr>
                  <th>구분</th>
                  <th>처리부서</th>
                  <th>연락처</th>
                  <th>E-Mail</th>
                </tr>
                <tr>
                  <td class="bg-td text-center">안전환경 통합시스템</td>
                  <td class="text-center">안전환경 기획팀</td>
                  <td class="text-center">02-317-1187</td>
                  <td class="text-center">hyeonsu1.song@dongkuk.com</td>
                </tr>
              </table>
            </div>
          </li>
        </ul>
      </section>

      <section>
        <h4>■ 권익침해 구제방법</h4>
        <ul>
          <li class="content" data-content="①">
            정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에
            문의하시기 바랍니다.
          </li>
          <li>
            <div class="overflow-x-auto">
              <table class="bg-table" style="min-width: 640px">
                <colgroup>
                  <col style="width: 193px" />
                  <col style="width: 193px" />
                  <col style="width: 193px" />
                </colgroup>
                <tr>
                  <th>처리기관</th>
                  <th>연락처</th>
                  <th>홈페이지 URL</th>
                </tr>
                <tr>
                  <td class="bg-td text-center">개인정보분쟁조정위원회</td>
                  <td class="text-center">(국번없이) 1833-6972</td>
                  <td class="text-center">www.kopico.go.kr</td>
                </tr>
                <tr>
                  <td class="bg-td text-center">개인정보침해신고센터</td>
                  <td class="text-center">(국번없이) 118</td>
                  <td class="text-center">privacy.kisa.or.kr</td>
                </tr>
                <tr>
                  <td class="bg-td text-center">대검찰청</td>
                  <td class="text-center">(국번없이) 1301</td>
                  <td class="text-center">www.spo.go.kr</td>
                </tr>
                <tr>
                  <td class="bg-td text-center">경찰청</td>
                  <td class="text-center">(국번없이) 182</td>
                  <td class="text-center">ecrm.cyber.go.kr</td>
                </tr>
              </table>
            </div>
          </li>
          <li class="content" data-content="②">동국제강은 정보주체의 개인정보자기결정권을 보장하고, 개인정보 침해로 인한 상담 및 피해 구제를 위해 노력하고 있으며, 신고나 상담이 필요한 경우 아래의 담당부서로 연락해 주시기 바랍니다.</li>
          <li>
            <p>‣ 개인정보 열람청구 접수ㆍ처리 담당부서</p>
            <div class="overflow-x-auto">
              <table class="bg-table" style="min-width: 640px">
                <colgroup>
                  <col style="width: 132px" />
                  <col style="width: 119px" />
                  <col style="width: 119px" />
                  <col style="width: 210px" />
                </colgroup>
                <tr>
                  <th>구분</th>
                  <th>처리부서</th>
                  <th>연락처</th>
                  <th>E-Mail</th>
                </tr>
                <tr>
                  <td class="bg-td text-center">안전환경 통합시스템</td>
                  <td class="text-center">안전환경 기획팀</td>
                  <td class="text-center">02-317-1187</td>
                  <td class="text-center">hyeonsu1.song@dongkuk.com</td>
                </tr>
              </table>
            </div>
          </li>
        </ul>
      </section>

      <section>
        <h4>■ 개인정보 처리방침의 변경</h4>
        <ul>
          <li class="content" data-content="①">이 개인정보 처리방침은 2026. 1. 2(개정일)부터 적용됩니다.</li>
        </ul>
      </section>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  watch: {
    value(data) {
      this.showPopup = data;
    },
    showPopup(data) {
      this.$emit("input", data);
    },
  },
  data() {
    return {
      showPopup: false,
    };
  },
};
</script>

<style scoped lang="scss">
#PopupPrivacyPolicy::v-deep .vs-popup {
  width: 784px;
}

section {
  margin-bottom: 20px;

  h4 {
    margin-bottom: 14px;
  }
}

li {
  margin-bottom: 10px;
}
li.content::before {
  content: attr(data-content) " ";
  position: absolute;
  left: 0;
  top: 0;
}
li.content {
  position: relative;
  padding-left: 1.5rem;
}

table {
  width: 100%;
  border-collapse: collapse;

  border: 1px solid #cdcdcd;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 8px;
  }

  th {
    font-size: 14px;
    text-align: center;
  }

  &.bg-table {
    th {
      background-color: #e7e7e7;
    }
  }

  .bg-td {
    background-color: #f9f9f9;
  }
}
</style>
